import translate from '../../../i18n'
import { CorporateCreditsBufferTypeEnums } from '../../../pages/corporates-container/constant'
import { Form, InputNumber, Radio, RadioChangeEvent, Space } from 'antd'
import React, { useEffect } from 'react'

interface IProps {
  isTrialCorporate?: boolean
}

const CreditsDistributionBufferInput = (props: IProps) => {
  const { isTrialCorporate } = props

  const [fixedBuffer, setFixedBuffer] = React.useState(false)

  const form = Form.useFormInstance()

  useEffect(() => {
    const bufferType = form.getFieldValue('bufferType')
    setFixedBuffer(bufferType == CorporateCreditsBufferTypeEnums.FIXED)
  }, [form.getFieldValue('bufferType')])

  const onBufferTypeChange = (e: RadioChangeEvent) => {
    setFixedBuffer(e.target.value == CorporateCreditsBufferTypeEnums.FIXED)
  }

  return (
    <>
      <Form.Item
        label={translate('corporate.bufferType')}
        name="bufferType"
        rules={[
          {
            required: true,
            message: translate('corporate.bufferType.required'),
          },
        ]}
      >
        <Radio.Group onChange={onBufferTypeChange}>
          <Radio value={CorporateCreditsBufferTypeEnums.PERCENTAGE}>
            {translate('corporate.bufferTypeOption.percentage')}
          </Radio>
          <Radio value={CorporateCreditsBufferTypeEnums.FIXED}>
            {translate('corporate.bufferTypeOption.fixed')}
          </Radio>
        </Radio.Group>
      </Form.Item>
      {!fixedBuffer && (
        <Form.Item
          label={translate('corporate.bufferPercentage')}
          rules={[
            {
              required: true,
              message: translate('corporate.bufferPercentage.required'),
            },
          ]}
        >
          <Space.Compact>
            <Form.Item name="bufferPercentage" noStyle>
              <InputNumber disabled={isTrialCorporate} min={0} />
            </Form.Item>
            <div className="addon-after">%</div>
          </Space.Compact>
        </Form.Item>
      )}
      {fixedBuffer && (
        <Form.Item
          label={translate('corporate.bufferFixedValue')}
          name="bufferFixedValue"
          rules={[
            {
              required: true,
              message: translate('corporate.bufferFixedValue.required'),
            },
          ]}
        >
          <InputNumber disabled={isTrialCorporate} min={0} />
        </Form.Item>
      )}
    </>
  )
}

export default CreditsDistributionBufferInput
